// extracted by mini-css-extract-plugin
export default {"root":"locale_select_desktop_root__zvbnS","defaultLanguage":"locale_select_desktop_defaultLanguage__SURdG"};